interface IFormTerms {
    classes?: string,
}

/**
 * Common form terms & privacy links.
 */
const FormTerms = (props: IFormTerms) => {
    return (
        <div className={ props.classes ? props.classes : `flex justify-end mt-4 text-sm`}>
            <a href="/legal/privacy-policy" title="" className="text-gray-500 mr-4 no-underline">Privacy</a>
            <a href="/legal/terms-and-conditions" title="" className="text-gray-500 no-underline">Terms</a>
        </div>
    )
};

export default FormTerms;